import { useQuery } from '@tanstack/vue-query'
import { propertyKeys } from './propertyQueryKeys'
import { getPortfolioStatus } from './propertyEndpoints'
import { parsePortfolioStatus } from './propertyParser'

// Portfolio Status tiles. Computed server-side over the seller's whole portfolio
// (not the current page), so this is a separate query from the paginated list
// rather than something derived from the loaded rows.
export function usePortfolioStatusQuery() {
  return useQuery({
    queryKey: propertyKeys.portfolioStatus(),
    queryFn: () => getPortfolioStatus().then(parsePortfolioStatus),
  })
}
